export const TOKEN = () => localStorage.getItem('token');
